import { createSlice } from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit'
import { nanoid } from 'nanoid'

import { SnackBar } from './snackbar.types'

const initialState: SnackBar[] = []

const { actions, reducer } = createSlice({
  name: 'snackbar',
  initialState,
  reducers: {
    pushSnackbar: (state, action: PayloadAction<SnackBar>) => {
      state.push(action.payload)
    },

    removeSnackbar: (state, action: PayloadAction<string | number>) => {
      return state.filter(({ id }) => id !== action.payload)
    }
  }
})

const { pushSnackbar, removeSnackbar } = actions

const pushDangerNotification = (message: string, isDismissed?: boolean) =>
  pushSnackbar({
    id: nanoid(),
    kind: 'error',
    message,
    isDismissed
  })
const pushWarningNotification = (message: string, isDismissed?: boolean) =>
  pushSnackbar({
    id: nanoid(),
    kind: 'warning',
    message,
    isDismissed
  })
const pushSuccessNotification = (message: string, isDismissed?: boolean) =>
  pushSnackbar({
    id: nanoid(),
    kind: 'success',
    message,
    isDismissed
  })
const pushInfoNotification = (message: string, isDismissed?: boolean) =>
  pushSnackbar({
    id: nanoid(),
    kind: 'info',
    message,
    isDismissed
  })

const snackbarSelector = <T extends { snackbar: SnackBar[] }>(state: T) =>
  state.snackbar

export {
  snackbarSelector,
  pushDangerNotification,
  pushWarningNotification,
  pushSuccessNotification,
  pushInfoNotification,
  removeSnackbar,
  reducer as snackbarReducer
}
